import React from 'react';

import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiInvertColors } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { CUSTOMIZATION } from '../../keys';
import { adminMobileCustomizationRoute } from '../../routes';

interface MobileCustomizationSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

export const MobileCustomizationSideNavigation: React.FC<MobileCustomizationSideNavigationProps> = ({
    isAllowed,
    ...restOfProps
}) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            icon={mdiInvertColors}
            label={translateKey(CUSTOMIZATION.TITLE_CUSTOMIZATION)}
            route={adminMobileCustomizationRoute}
        />
    );
};

MobileCustomizationSideNavigation.displayName = 'SideNavigationItem';
